import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const TikTok = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads.
    </p>
    <CopyUtmParams
      className="my-3 max-w-2xl"
      platform={NorthbeamUtmPlatform.TIKTOK}
      hideQuestionMark
      aggregateMultipleParams={false}
    />
    <p className="mb-0">
      Paste the text you copied above into the location provided in these
      instructions:{" "}
    </p>
    <iframe
      src="https://www.loom.com/embed/d7b028f553c64c63a6683bbd0e276f3e"
      title="Tiktok UTM tracking description"
      width="100%"
      height="500"
      frameBorder="0"
    />
  </div>
);
